import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

// CSV Export
export const exportCSV = (title, columns, rows) => {
    const header = columns.map(col => col.label).join(",");
    const csvRows = rows
        .map(row => columns.map(col => row[col.key] ?? "").join(","))
        .join("\n");

    const csvContent = header + "\n" + csvRows;
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `${title}.csv`;
    link.click();
};


// Excel Export
export const exportExcel = (title, columns, rows) => {
    const worksheetData = [
        columns.map(c => c.label),               // Header row
        ...rows.map(row => columns.map(c => row[c.key] ?? ""))  // Data rows
    ];

    const ws = XLSX.utils.aoa_to_sheet(worksheetData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Report");

    XLSX.writeFile(wb, `${title}.xlsx`);
};
 
export const exportPDF = (title, columns, rows) => {
    const doc = new jsPDF();

    doc.text(title, 14, 14);

  autoTable(doc, {
        head: [columns.map(c => c.label)],
        body: rows.map(row => columns.map(c => row[c.key] ?? "")),
        startY: 20,
    });


    doc.save(`${title}.pdf`);
};

